import { Component, Inject, OnInit, EventEmitter } from '@angular/core';
import { HandlerModal } from '../../handler-modals';
import { DAyudasFormularioNoExperto } from '../../../../../../configuracion/dayudas-formulario-no-experto';
import { MAT_DIALOG_DATA,MatDialogRef } from '@angular/material';
import { DDocumento } from '@dian/api-formulario';
import { DirectionType } from '../../handler-modals';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { MessageObservableService } from '../../../../../../services/message-observable.service';
import { DTasaCambioCompleto, DTasaCambioSimple } from '@dian-api/renta210v18';
import { DBasicosParametricasServicios, DValorPeriodico, DValorDominio } from '@dian/api-basicos-parametricas';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo
const ID_CAS_INDICADOR_AVANCE='cs_id_142';

const stepsList = [
  { text: "1", active: true, completed: false, tooltip: 'Lista de Activos Moneda extranjera', listHelp: ['163'] }
];

const tableStructure = [
    {id: 'desc', title: 'Descripción'}, 
    {id: 'valorCOP', title: 'Valor a declarar'}
];

class Form1 {
  id: number;
  desc: string;
  moneda: string;
  fechaAdquisicion: string;
  valMonedaExtranjera: string;
  trmCOP: number;
  valorCOP: string;
}

class MonedasDominio {
  valor: string;
  nombre: string;
}

@Component({
  selector: 'app-patrimonio-activos-extranjera-modal',
  templateUrl: './patrimonio-activos-extranjera-modal.component.html',
  styleUrls: ['./patrimonio-activos-extranjera-modal.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio, 
    DValorDominio 
  ]
})
export class PatrimonioActivosExtranjeraModalComponent extends HandlerModal implements OnInit {

  public dataSourceHeader = tableStructure;
  public dataSourceBody = [];
  public modelForm: Form1 = new Form1();
  public listaMoneda: DValorDominio[] = [];

  public OPERACION_NULA:number = 0;
  public OPERACION_AGREGAR:number = 1;
  public OPERACION_EDITAR:number = 2;
  public OPERACION_BORRAR:number = 3; 
  public operacionTabla:number = this.OPERACION_NULA;

  public precargaProceso;

  saveModel = new EventEmitter();
  getTRM = new EventEmitter();
  public showSave:boolean;
  mensajeTabla = "Agregue, edite o elimine sus ingresos según su realidad económica.";

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    public dialogRef: MatDialogRef<PatrimonioActivosExtranjeraModalComponent>,
    private _messagesObs: MessageObservableService,
    @Inject(MAT_DIALOG_DATA) public model: DDocumento
  ) { 
    super(stepsList, DAyudasFormularioNoExperto.AYUDAS_FORMULARIO);

    console.log(model);
  }

  
  ngOnInit() {
    this.initializeMonedas();
    this.inicializeModelo();
    this.inicializeForm();
    this.initializeTablaDesdeModelo();
   // this.validateShowSave();
    this.listenMessagesObs();
  }

  protected inicializeForm(){
    this.modelForm = new Form1();
    this.modelForm.id=0;
    this.modelForm.desc="";
    this.modelForm.moneda="";
    this.modelForm.fechaAdquisicion="";
    this.modelForm.valMonedaExtranjera="0";
    this.modelForm.trmCOP=0;
    this.modelForm.valorCOP="0";
  }
  
  protected inicializeModelo(){
    if(this.model.doc.cuerpo.cc_id_234 == undefined){
      this.model.doc.cuerpo.cc_id_234 = [];
      this.model.doc.cuerpo.cc_id_236 = [];
      this.model.doc.cuerpo.cc_id_235 = [];
      this.model.doc.cuerpo.cc_id_237 = [];
      this.model.doc.cuerpo.cc_id_238 = [];
      this.model.doc.cuerpo.cc_id_239 = [];
      this.model.doc.cuerpo.cs_id_164 = "0";
    }  
  }

  protected initializeMonedas(){
    
  }

  public operacionCs164(){
    let suma = "0";
    for(let i=0; i<this.dataSourceBody.length; i++){
      suma = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA,this.dataSourceBody[i].valorCOP.toString(), suma);
    }
    this.model.doc.cuerpo.cs_id_164 = suma;
  }

  
  //////////////////////

  protected initializeTablaDesdeModelo(){
    this.dataSourceBody = [];
    for(let i=0; i<this.model.doc.cuerpo.cc_id_234.length; i++){
      this.modelForm.id=i;
      this.modelForm.desc=this.model.doc.cuerpo.cc_id_234[i].v;
      this.modelForm.moneda=this.model.doc.cuerpo.cc_id_236[i].v;
      this.modelForm.fechaAdquisicion=this.model.doc.cuerpo.cc_id_235[i].v;
      this.modelForm.valMonedaExtranjera=this.model.doc.cuerpo.cc_id_237[i].v;
      this.modelForm.trmCOP=this.model.doc.cuerpo.cc_id_238[i].v;
      this.modelForm.valorCOP=this.model.doc.cuerpo.cc_id_239[i].v;
      this.redondearFormData();
      this.dataSourceBody.push(this.modelForm);
      this.inicializeForm();
    }
  }

  public editModeloDesdeForm(){
    this.model.doc.cuerpo.cc_id_234[this.modelForm.id].v=this.modelForm.desc;
    this.model.doc.cuerpo.cc_id_236[this.modelForm.id].v=this.modelForm.moneda.toString();
    this.model.doc.cuerpo.cc_id_235[this.modelForm.id].v=this.modelForm.fechaAdquisicion.toString();
    this.model.doc.cuerpo.cc_id_237[this.modelForm.id].v=this.modelForm.valMonedaExtranjera.toString();
    this.model.doc.cuerpo.cc_id_238[this.modelForm.id].v=this.modelForm.trmCOP.toString();
    this.model.doc.cuerpo.cc_id_239[this.modelForm.id].v=this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorCOP.toString());
  }

  public addToModeloDesdeForm(){
    let i=this.modelForm.id+1;
    this.model.doc.cuerpo.cc_id_234.push({it: i, v:this.modelForm.desc});
    this.model.doc.cuerpo.cc_id_236.push({it: i, v:this.modelForm.moneda.toString()});
    this.model.doc.cuerpo.cc_id_235.push({it: i, v:this.modelForm.fechaAdquisicion.toString()});
    this.model.doc.cuerpo.cc_id_237.push({it: i, v:this.modelForm.valMonedaExtranjera.toString()});
    this.model.doc.cuerpo.cc_id_238.push({it: i, v:this.modelForm.trmCOP.toString()});
    this.model.doc.cuerpo.cc_id_239.push({it: i, v:this.dutilidades.deshacerFormatoMoneda(this.modelForm.valorCOP.toString())});
  }

  public deleteOnModel(index:number){
    this.model.doc.cuerpo.cc_id_234.splice(index,1);
    this.model.doc.cuerpo.cc_id_236.splice(index,1);
    this.model.doc.cuerpo.cc_id_235.splice(index,1);
    this.model.doc.cuerpo.cc_id_237.splice(index,1);
    this.model.doc.cuerpo.cc_id_238.splice(index,1);
    this.model.doc.cuerpo.cc_id_239.splice(index,1);

    //reenumerear it
    for(let i=0;i<this.model.doc.cuerpo.cc_id_234.length;i++){
      this.model.doc.cuerpo.cc_id_234[i].it=i+1;
      this.model.doc.cuerpo.cc_id_236[i].it=i+1;
      this.model.doc.cuerpo.cc_id_235[i].it=i+1;
      this.model.doc.cuerpo.cc_id_237[i].it=i+1;
      this.model.doc.cuerpo.cc_id_238[i].it=i+1;
      this.model.doc.cuerpo.cc_id_239[i].it=i+1;
    }
  }

  public validateFormCompleted():boolean{
    return this.modelForm.desc==undefined || this.modelForm.desc=="" ||
        this.modelForm.moneda==undefined || 
        this.modelForm.fechaAdquisicion==undefined || this.modelForm.fechaAdquisicion=="" ||
        this.modelForm.valMonedaExtranjera==undefined || this.modelForm.valMonedaExtranjera=="0" ||
        this.modelForm.valorCOP==undefined || this.modelForm.valorCOP=="0";
  }

  public redondearFormData(){
    this.modelForm.valorCOP=this.dutilidades.redondearValorMoneda(this.modelForm.valorCOP.toString(),true);
    
  }
  

  public calcularValoresForm(){
  //  this.modelForm.id = this.dataSourceBody.length;
    this.modelForm.valMonedaExtranjera=this.dutilidades.obtenerFormatoMoneda(this.modelForm.valMonedaExtranjera);
    let resultado = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.MULTIPLICACION,this.modelForm.trmCOP.toString(), this.modelForm.valMonedaExtranjera.toString(),true);
    this.modelForm.valorCOP=this.dutilidades.redondearValorMoneda(resultado,true);
  }

  public changeDataTRM(){//Si tiene fecha y moneda llama rest TRM
    if(this.modelForm.moneda!=undefined && this.modelForm.moneda!="" && 
      this.modelForm.fechaAdquisicion!=undefined && this.modelForm.fechaAdquisicion!=""){
        let tasaCambioSolicitud:DTasaCambioSimple = new DTasaCambioSimple();
        tasaCambioSolicitud.moneda=this.modelForm.moneda;
        let tasaCambioCompleto:DTasaCambioCompleto = new DTasaCambioCompleto();
        let fecha= this.modelForm.fechaAdquisicion.split("-").join("");
        if(fecha > "20231231"){
          let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe seleccionar una fecha menor o igual al 31 de diciembre de 2023" );
          this.modelForm.fechaAdquisicion="";
          this.modelForm.trmCOP=0;
          this.modelForm.valorCOP="0";
          return;
        }
        if(fecha < "20161231"){
          fecha = "20161231";
        }
        tasaCambioCompleto.fecha=fecha;
        tasaCambioCompleto.tasaCambioSolicitud = tasaCambioSolicitud;
        this.getTRM.emit(tasaCambioCompleto);
        this.precargaProceso = this.dNotificacionServicio.mostrarDialogoCarga();
    }else{
      this.modelForm.trmCOP=0;
      this.modelForm.valorCOP="0";
    }
  }
  
  private listenMessagesObs() {//Recepcion de data del rest TRM
    this._messagesObs.getMessages().subscribe(res => {
      if (res.operation === 'trmCompleto') {
        if(this.precargaProceso!=undefined)this.precargaProceso.close();
        if(res.message!=null){
          this.modelForm.trmCOP=res.message.tasaCambioSolicitud.valor;
          this.calcularValoresForm();
        }else{
          this.modelForm.trmCOP=0;
          this.modelForm.valorCOP="0";
        }
        if(this.modelForm.trmCOP==0){
          let dialogError = this.dNotificacionServicio.mostrarDialogoInformacion("No se encontraron datos para la moneda seleccionada, se recomienda realizar la conversión a USD" );
        }
      }
    });
  }

  saveItem(): void {
    if(this.validateFormCompleted()){
      let dialogError = this.dNotificacionServicio.mostrarDialogoError("Debe diligenciar todos los campos para agregar un nuevo registro" );
      return;
    }else{
      this.redondearFormData();
      if (this.operacionTabla==this.OPERACION_EDITAR){
        //this.editModeloDesdeForm();
        this.dataSourceBody.forEach((el)=>{
          if(el.id == this.modelForm.id){
            el=this.modelForm;
          }
        });
      }else if (this.operacionTabla==this.OPERACION_AGREGAR){
        this.modelForm.id = this.dataSourceBody.length;
        this.dataSourceBody.push(this.modelForm);
        //this.addToModeloDesdeForm();
      }
      //Recalcular y reinicializar
      this.operacionCs164();
      this.inicializeForm();
      this.operacionTabla=this.OPERACION_NULA;
    }
  }

  eventTable($event: string): void {
    if($event === 'add') this.operacionTabla=this.OPERACION_AGREGAR;
    if($event === 'edit') this.operacionTabla=this.OPERACION_EDITAR;
    if($event === 'delete') this.operacionTabla=this.OPERACION_BORRAR;
    this.operacionCs164();
  }

  updateItemSelected($event: any): void {
    let index = $event;
    if(this.operacionTabla==this.OPERACION_EDITAR){//editando
      this.modelForm = this.dataSourceBody[index];
    }
    if(this.operacionTabla==this.OPERACION_BORRAR){//borrando
      //this.deleteOnModel(index);
      this.operacionTabla=this.OPERACION_NULA;
     
    }
  }
  
  cancel(): void {
    this.inicializeForm();
    this.operacionTabla=this.OPERACION_NULA;
  }

  
  ///////////////////////

  //Aplica si dentro del modal hay preguntas SI/NO que bloquean el avance
  public validateRbQuestions(val: string) {

  }
  
  //Aplica para revisar si hay preguntas que se habilitaron con una previa respuesta SI en el modal
  protected validateHasModalValues(indexQuestion:number): boolean{
    let hasValues:boolean = false;
    return hasValues;
  }

  //Aplica normalmente si se cambia el valor SI a NO en una pregunta del modal y deben eliminarse valores los valores previamente diligenciados
  protected cleanModalValues(indexQuestionModal:number){
    
  }
  
  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateStepHabilitado(indexS:number):boolean{
    let habilitado = true;
    return habilitado;
  }

  //Aplica si dentro del modal existen condiciones que deshabilite el avance (como preguntas SI/NO)
  public validateBtnRightActive(){

  }

  //////////////////////////
  
  protected obtenerCasIndicadorAvance():string{
    if(this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==undefined){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]="0";
    }
    return this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE];
  }
  protected updateIndicadorAvance(){
    /* let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(this.indexStepper> Number(casIndicadorAvance)){
      let indexS = this.indexStepper+1;
      while(!this.validateStepHabilitado(indexS)){
        indexS++;
      }
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=indexS.toString();
    }
    if(this.indexStepper==this.stepsList.length-1){
      this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]=VAL_INDICADOR_COMPLETO;
    } */
  }


  protected controlStep(direction: DirectionType): void {
    this.changeStepLocal(this.indexStepper, true);
  }

  public changeStepLocal(index: number, forceUpdateStepper?:boolean){
   /*  let casIndicadorAvance=this.obtenerCasIndicadorAvance();
    if(forceUpdateStepper){
      this.changeStep(index);
      this.updateIndicadorAvance();
    }else if(this.validateStepHabilitado(index)){
      let indexCalc = index-1;
      if(indexCalc<=Number(casIndicadorAvance)){
        this.changeStep(index);
        this.updateIndicadorAvance();
      }else{
        console.log("Avance no permitido: casIndicadorAvance=" + casIndicadorAvance + ", index-1="+(indexCalc));
      }
    }
    this.validateBtnRightActive();
    this.validateShowSave(); */
  }
  
  protected validateShowSave(){
    if(this.indexStepper==this.stepsList.length-1 || this.model.doc.cuerpo[ID_CAS_INDICADOR_AVANCE]==VAL_INDICADOR_COMPLETO){ this.showSave=true };
  }

  public closeModal(){
    this.initializeTablaDesdeModelo();
    this.dialogRef.close("");
  }

  public guardar(){
     //Limpiar modelo y agregar el contenido de la tabla
     this.model.doc.cuerpo.cc_id_234 = undefined;
     this.inicializeModelo();
     for(let i=0; i<this.dataSourceBody.length; i++){
       this.modelForm = this.dataSourceBody[i];
       this.addToModeloDesdeForm();
     }
     this.operacionCs164();
    
    this.saveModel.emit(true);
    //if(this.indexStepper==this.stepsList.length-1){
      this.closeModal();
    //}
  }

  protected cleanInput(nameInput: string): void {
    if(this.modelForm[nameInput] == "0" || this.modelForm[nameInput] == "")
      this.modelForm[nameInput] = '';
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/patrimonio/patrimonio-activos-extranjera-modal/patrimonio-activos-extranjera-modal.component.ts